var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _vm.$store.getters.role == 1 || _vm.$store.getters.role == 2
        ? [
            _c("div", { staticClass: "container-fluid xyz" }, [
              _c("div", { staticClass: "page-header-top-container" }, [
                _c("div", { staticClass: "page-name" }, [
                  _vm._v("Hourly Report")
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.exportTicket($event)
                      }
                    }
                  },
                  [_vm._v("Export")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "admin-page-content" }, [
                _c("div", { staticClass: "card" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "card-header",
                      staticStyle: { background: "#f5f5f5" }
                    },
                    [
                      _c("div", { staticClass: "selectdate" }, [
                        _c(
                          "div",
                          { staticClass: "selectbox1" },
                          [
                            _c("v-select", {
                              attrs: {
                                name: "location",
                                placeholder: "Type location here",
                                label: "location_name",
                                options: _vm.locationOptions
                              },
                              on: {
                                change: _vm.loadTickets,
                                input: function($event) {
                                  return _vm.changeLocation()
                                }
                              },
                              model: {
                                value: _vm.selectedLocation,
                                callback: function($$v) {
                                  _vm.selectedLocation = $$v
                                },
                                expression: "selectedLocation"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.locationError))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "selectbox1" },
                          [
                            _c("VueCtkDateTimePicker", {
                              attrs: {
                                range: "",
                                "only-date": _vm.date_picker_options.onlyDate,
                                "only-time": false,
                                "output-format":
                                  _vm.date_picker_options.outputFormat,
                                format: _vm.date_picker_options.inputFormat,
                                formatted: _vm.date_picker_options.formatted,
                                noClearButton:
                                  _vm.date_picker_options.noClearButton,
                                "custom-shortcuts":
                                  _vm.date_picker_options.customShortcuts,
                                maxDate: _vm.date_picker_options.maxDate
                              },
                              on: {
                                input: function($event) {
                                  return _vm.changeDatePickerDate()
                                }
                              },
                              model: {
                                value: _vm.date_picker_dates,
                                callback: function($$v) {
                                  _vm.date_picker_dates = $$v
                                },
                                expression: "date_picker_dates"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.datePickerError))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "selectbtn" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-warning applybtn",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.loadTickets()
                                }
                              }
                            },
                            [_vm._v("Apply Filter")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary clearbtn",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.clearFilter()
                                }
                              }
                            },
                            [_vm._v("Clear Filter")]
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "app-filter-good-table-container hourly-report-table"
                  },
                  [
                    _c("vue-good-table", {
                      ref: "ticketList",
                      attrs: {
                        mode: "remote",
                        totalRows: _vm.totalRecords,
                        columns: _vm.columns,
                        rows: _vm.rows,
                        "sort-options": {
                          enabled: false
                        },
                        "pagination-options": {
                          enabled: false,
                          mode: "pages",
                          pageLabel: "Page",
                          position: "bottom",
                          perPage: _vm.serverParams.perPage,
                          perPageDropdown: [25, 50, 100, 200, 500],
                          dropdownAllowAll: false
                        },
                        "search-options": {
                          enabled: false
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "table-column",
                            fn: function(props) {
                              return [
                                _vm.isRequiredColumnLabel(props.column.field)
                                  ? _c("span", [
                                      _c(
                                        "div",
                                        { staticClass: "custom-header-date" },
                                        [_vm._v(_vm._s(props.column.key))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "custom-header-label",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              props.column.label
                                            )
                                          }
                                        },
                                        [_vm._v(_vm._s(props.column.label))]
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(props.column.label) +
                                          "\n                            "
                                      )
                                    ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        473833964
                      )
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        : [_c("no-permission")],
      _vm._v(" "),
      _c("app-footer")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a74e696", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a74e696","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HourlyReport.vue
// module id = null
// module chunks = 